import { z } from 'zod';

export const contactPublicFieldSchema = z.object({
  name: z
    .string()
    .trim()
    .min(1, { message: 'Name is required' })
    .max(100, { message: 'Name must be 100 characters or fewer' }),
  email: z
    .string()
    .trim()
    .min(1, { message: 'Email is required' })
    .email({ message: 'Must be a valid email' })
    .max(254, { message: 'Email must be 254 characters or fewer' }),
  message: z
    .string()
    .trim()
    .min(10, { message: 'Message must be at least 10 characters' })
    .max(5000, { message: 'Message must be 5000 characters or fewer' }),
});

export const contactWireSchema = contactPublicFieldSchema.extend({
  website: z.string().max(200),
  submissionId: z.string().uuid({ message: 'Submission ID must be a UUID' }),
  turnstileToken: z
    .string()
    .min(1)
    .max(2048, { message: 'Verification token is invalid' })
    .optional(),
});

export const formSchema = z.object({
  email: contactPublicFieldSchema.shape.email,
  message: contactPublicFieldSchema.shape.message,
});

export type TFormSchema = z.infer<typeof formSchema>;
export type ContactWireInput = z.infer<typeof contactWireSchema>;

export const CONTACT_WIRE_FIELDS = [
  'name',
  'email',
  'message',
  'website',
  'submissionId',
  'turnstileToken',
] as const;
